import { render, staticRenderFns } from "./ItemIncidencias.vue?vue&type=template&id=3e7b805a&"
import script from "./ItemIncidencias.vue?vue&type=script&lang=js&"
export * from "./ItemIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports